import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-review-dialog',
  templateUrl: './review-dialog.component.html',
  styleUrls: ['./review-dialog.component.scss']
})
export class ReviewDialogComponent {
  // Equipment Section
  equipmentRating = 0;
  equipmentFinalReview = '';
  equipmentQuestions = [
    { question: 'How was the equipment condition?', answer: 0, label: 'Vehicle Condition' },
    { question: 'How was the vendor service?', answer: 0, label: 'Vendor Service' },
    { question: 'Was the delivery on time?', answer: 0, label: 'On-time Delivery' }
  ];

  // Vendor Section
  vendorRating = 0;
  vendorFinalReview = '';
  vendorQuestions = [
    { question: "How was the vendor's communication?", answer: 0, label: 'Communication' },
    { question: 'Was the vendor professional?', answer: 0, label: 'Professionalism' },
    { question: 'How was the overall transaction experience?', answer: 0, label: 'Experience' }
  ];

  // Customer Section (For Vendor Rating Customer)
  customerRating = 0;
  customerFinalReview = '';
  customerQuestions = [
    { question: "How was the customer's communication?", answer: 0, label: 'Communication' },
    { question: 'Was the customer professional?', answer: 0, label: 'Professionalism' },
    { question: 'How was the overall transaction experience?', answer: 0, label: 'Experience' }
  ];

  constructor(
    private dialogRef: MatDialogRef<ReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.existingReview) {
      const r = data.existingReview;
      
      // Load Equipment Feedback
      this.equipmentRating = r.equipment?.rating || r.rating || 0;
      this.equipmentFinalReview = r.equipment?.finalReview || r.equipment?.comment || r.finalReview || '';
      if (r.equipment?.questions) {
        this.equipmentQuestions = this.equipmentQuestions.map(q => {
          const found = r.equipment.questions.find((eq: any) => eq.question === q.question);
          return found ? { ...q, answer: found.answer } : q;
        });
      }

      // Load Vendor Feedback
      this.vendorRating = r.vendor?.rating || 0;
      this.vendorFinalReview = r.vendor?.finalReview || r.vendor?.comment || '';
      if (r.vendor?.questions) {
        this.vendorQuestions = this.vendorQuestions.map(q => {
          const found = r.vendor.questions.find((vq: any) => vq.question === q.question);
          return found ? { ...q, answer: found.answer } : q;
        });
      }

      // Load Customer Feedback (Vendor Mode)
      this.customerRating = r.customer?.rating || (this.data.isVendorMode ? (r.rating || 0) : 0);
      this.customerFinalReview = r.customer?.finalReview || r.customer?.comment || (this.data.isVendorMode ? (r.finalReview || '') : '');
      if (r.customer?.questions) {
        this.customerQuestions = this.customerQuestions.map(q => {
          const found = r.customer.questions.find((cq: any) => cq.question === q.question);
          return found ? { ...q, answer: found.answer } : q;
        });
      }
    }
  }

  setQuestionRating(q: any, rating: number) {
    q.answer = rating;
  }

  close() {
    this.dialogRef.close(null);
  }

  submit() {
    const result: any = {
      equipment: {
        rating: this.equipmentRating,
        questions: this.equipmentQuestions.map(q => ({ question: q.question, answer: q.answer })),
        finalReview: this.equipmentFinalReview
      },
      vendor: {
        rating: this.vendorRating,
        questions: this.vendorQuestions.map(q => ({ question: q.question, answer: q.answer })),
        finalReview: this.vendorFinalReview
      },
      customer: {
        rating: this.customerRating,
        questions: this.customerQuestions.map(q => ({ question: q.question, answer: q.answer })),
        finalReview: this.customerFinalReview
      }
    };

    // Keep legacy fields for partial compatibility
    if (this.data.isVendorMode) {
      result.rating = this.customerRating;
      result.finalReview = this.customerFinalReview;
      result.questions = result.customer.questions;
    } else {
      result.rating = this.equipmentRating;
      result.finalReview = this.equipmentFinalReview;
      result.questions = result.equipment.questions;
    }

    this.dialogRef.close(result);
  }
}
